import React, { useEffect, useState, useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, Input, FormGroup, Button, Label, Form, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import moment from 'moment';
import './feedback.css';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';
import Table from './common/Table';


const common = require('../utils/Common');

const Query = () => {
    const [QueryData, setQueryData] = useState([]);
    const [replyData, setReplyData] = useState([]);
    const [modal, setModal] = useState(false);
    const [QueryReply, setQueryReply] = useState('');
    const [totalRecords, setTotalRecords] = useState(0);
    const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});
    

    const navigate = useNavigate();

    const toggle = () => setModal(!modal);

    useEffect(() => {
        checkAccess();
    }, []);
    
    const checkAccess = async () => {
        let rights = await common.checkAccessRights(window.location.pathname);
        if (!rights.view) {
            alert("Access Denied");
            navigate("/");
            return;
        } else {
            setUserRights(rights);
            getQuery();
        }
    }

    const getQuery = async (limit = 10, offset = 0, search = {}) => {
        const parameters = {
            source: 'admin',
            'fromDate': $('#Date-from').val(),
            'toDate': $('#Date-to').val(),
            'limit': limit,
            'offset': offset
        };
        let response = await common.apiRequest('post', '/users/QueryDetails', parameters);
        let data = (response.data && response.data.data) ? response.data.data : [];
        setQueryData(data);
        setTotalRecords(response.data.totalRecords);
    };

    const invoiceId = replyData?.order_item?.order?.invoices?.[0]?.id;

    const reply = async () => {
        const parameters = {
            query_id: replyData.id,
            query_reply: QueryReply,
            invoice_id: invoiceId,
            query_reply_by: "Admin",
            source: "admin",
        };

        let response = await common.apiRequest('post', '/users/user-Query', parameters);
        if (response.status === 200) {
            if (response.data.code === "success") {
                alert(response.data.message);
                await getQuery();
            } else {
                alert(response.data.error);
            }
        }
        setModal(false);
    };

    const replyQuery = (data) => {
        setReplyData(data);
        toggle();
    };

    const columns = [
    { header: "User Id", accessor: "user.reg_id", width: 150 },
    {
        header: "Invoice No",
        accessor: "invoice_no",
        render: row => {
        const invoices = row?.order_item?.order?.invoices || [];
        const sellerProductInvoice = invoices.find(invoice =>
            invoice.invoice_type === 'seller_product' &&
            invoice.seller_id == row.seller_id
        );
        return sellerProductInvoice?.invoice_no || "N/A";
        },
        width: 150
    },
    { header: "User Query", accessor: "user_query", width: 200 },
    { header: "Order Id", accessor: "order_item.order.order_id", width: 150 },
    { header: "Order Date", accessor: "order_item.order.created_at", width: 150 },
    {
        header: "Date",
        accessor: "created_at",
        render: row => moment(row.created_at).format('YYYY-MM-DD') || "N/A",
        width: 150
    },
    { header: "Category", accessor: "type", width: 150 },

    {
        header: "Response from vendor",
        accessor: "vendor_response",
        render: row => {
        const vendorResponses = row.querys_replys
            .filter(reply => reply.query_reply_by === 'seller')
            .map(reply => reply.query_reply);
        return vendorResponses.length === 0 ? "No response" : vendorResponses.join('\n---\n');
        },
        wrapText: true,
        autoHeight: true,
        cellStyle: {
        whiteSpace: 'pre-wrap',
        maxHeight: '200px',
        overflowY: 'auto'
        }
    },
    {
        header: "Date of response (Vendor)",
        accessor: "vendor_response_date",
        render: row => {
        const dates = row.querys_replys
            .filter(reply => reply.query_reply_by === 'seller')
            .map(reply => reply.created_at);
        return dates.length === 0 ? "N/A" : dates.join('\n---\n');
        },
        wrapText: true,
        autoHeight: true,
        cellStyle: {
        whiteSpace: 'pre-wrap',
        maxHeight: '200px',
        overflowY: 'auto'
        }
    },
    {
        header: "Response from Admin",
        accessor: "admin_response",
        render: row => {
        const adminResponses = row.querys_replys
            .filter(reply => reply.query_reply_by === 'Admin')
            .map(reply => reply.query_reply);
        return adminResponses.length === 0 ? "No response" : adminResponses.join('\n---\n');
        },
        wrapText: true,
        autoHeight: true,
        cellStyle: {
        whiteSpace: 'pre-wrap',
        maxHeight: '200px',
        overflowY: 'auto'
        }
    },
    {
        header: "Date of response (Admin)",
        accessor: "admin_response_date",
        render: row => {
        const dates = row.querys_replys
            .filter(reply => reply.query_reply_by === 'Admin')
            .map(reply => reply.created_at);
        return dates.length === 0 ? "N/A" : dates.join('\n---\n');
        },
        wrapText: true,
        autoHeight: true,
        cellStyle: {
        whiteSpace: 'pre-wrap',
        maxHeight: '200px',
        overflowY: 'auto'
        }
    },
    {
        header: "Reply",
        accessor: "reply",
        render: row => (
        <button className='btn btn-primary btn-sm' onClick={() => replyQuery(row)}>
            View
        </button>
        ),
        width: 100
    }
    ];

    const rowData = QueryData.map((data, index) => {
        const vendorResponses = data.querys_replys?.filter(reply => reply.query_reply_by === 'seller') || [];
        const adminResponses = data.querys_replys?.filter(reply => reply.query_reply_by === 'Admin') || [];
    
        return {
            ...data,
            vendorResponses: vendorResponses.length > 0 
                ? vendorResponses.map(r => r.query_reply).join('\n---\n')
                : "No response",
            vendorResponseDates: vendorResponses.length > 0
                ? vendorResponses.map(r => r.created_at).join('\n')
                : "N/A",
            adminResponses: adminResponses.length > 0
                ? adminResponses.map(r => r.query_reply).join('\n---\n')
                : "No response",
            adminResponseDates: adminResponses.length > 0
                ? adminResponses.map(r => r.created_at).join('\n')
                : "N/A"
        };
    });
    
    const data = QueryData.map((data, index) => ({
        "Reg id": data.user.reg_id,
        "Invoice no": data.order_item?.order?.invoices?.find(invoice => invoice.invoice_type === 'seller_product' && invoice.seller_id == data.seller_id)?.invoice_no,
        "User Query": data.user_query,
        "Created at": data.created_at,
        "Type": data.type,
        "Vendor Response": rowData[index]?.vendorResponses,
        "Vendor Response Date": rowData[index]?.vendorResponseDates,
        "Admin Response": rowData[index]?.adminResponses,
        "Admin ResponseDate": rowData[index]?.adminResponseDates,
    }));


    const handleExportCSV = () => {
        exportToCSV(data, 'Admin Query');
    }

    const handleExportExcel = () => {
        exportToExcel(data, 'Admin Query');
    }

    const handleExportPDF = () => {
        exportToPDF(data, 'Admin Query');
    }
    return (
        <>
            <div className='Query-component'>
                <div>
                    <div className='Query-header col-md-12'>
                        <h2>Users Query</h2>
                    </div>
                    <div className="col-md-12">
                        <Form className='row'>
                            <FormGroup className='col-md-4 row'>
                                <Label className="col-md-2 col-form-label" for="Date-from">From:</Label>
                                <input type='date' defaultValue={moment().startOf('month').format('YYYY-MM-DD')} onChange={() => getQuery()} className="form-control col-md-5" id="Date-from" name="Date-from"></input>
                            </FormGroup>
                            <FormGroup className='col-md-4 row'>
                                <Label className=" col-md-2 col-form-label" for="Date-to">To:</Label>
                                <input type='date' defaultValue={moment().endOf('month').format('YYYY-MM-DD')} onChange={() => getQuery()} className="form-control col-md-5" id="Date-to" name="Date-to"></input>
                            </FormGroup>
                        </Form>
                    </div>
                    <button className='btn button-product' onClick={handleExportCSV}>Export to CSV</button>
                        <button className='btn button-product' onClick={handleExportExcel}>Export to Excel</button>
                        <button className='btn button-product' onClick={handleExportPDF}>Export to PDF</button>
                    <div className='ag-theme-alpine' style={{ height: 500, width: '100%' }}>
                        <Table
                            columns={columns}
                            data={rowData}
                            totalRecords={totalRecords}
                            pageSize={10}
                            onPageChange = {getQuery}
                        />
                    </div>
                </div>
            </div>

            <Modal isOpen={modal} toggle={toggle} size="xl">
                <ModalHeader toggle={toggle}>Query reply</ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label for="reply">Reply Query</Label>
                            <Input
                                type='text'
                                id="Query_reply"
                                value={QueryReply}
                                onChange={(e) => setQueryReply(e.target.value)}
                            />
                        </FormGroup>
                    </Form>
                    <Button className='submit' onClick={reply}>
                        Submit
                    </Button>
                </ModalBody>
            </Modal>
        </>
    );
};

export default Query;
